import React from 'react'
import styled from 'react-emotion'
import {
  RobotoRegular,
  RobotoThickMedium,
  RobotoLightMeduimSoft
} from '../../Text/styledComponents'
import IcYoutube from '../../Icons/IcYoutube'
import IcInstagram from '../../Icons/IcInstagram'
import IcFacebook from '../../Icons/IcFacebook'
import IcTwitter from '../../Icons/IcTwitter'

export const FooterSection = styled('div')`
  background-color: ${props => props.theme.footerSection.background};
  font-size: calc(16px - 0.1px);
  }
`
export const FooterMobile = styled(`div`)`
  padding: 2.143em 2.143em 4.286em 2.143em;
  align-items: center;
  display: flex;
  flex-direction: column;
`
export const FooterDesktop = styled(`div`)`
  display: flex;
  flex-direction: row;
  padding-top: 3.75em;
  padding-bottom: 3.375em;
  justify-content: space-between;
  flex-wrap: wrap;
`
export const Logo = styled('div')`
  margin-bottom: 1.875em;
  display: flex;
  align-items: center;
  flex-direction: column;
  @media (min-width: 1123px) {
    margin-bottom: 0px;
  }
`

export const EmailInput = styled(`input`)`
  border: none;
  width: 90%;
  text-align: center;
  font-size: 0.813em;
  background-color: transparent;
  outline: none;
  color: #ffffff;
  letter-spacing: 0.3px;
  ':focus': {
    border: none;
    outline: none;
    letter-spacing: 0.3px;
  }
  ::placeholder {
    color: ${props => props.theme.footerSection.inputText};
    letter-spacing: 0.3px;
  }

  :-ms-input-placeholder {
    color: ${props => props.theme.footerSection.inputText};
    letter-spacing: 0.3px;
  }

  ::-ms-input-placeholder {
    letter-spacing: 0.3px;
    color: ${props => props.theme.footerSection.inputText};
  }
  @media (min-width: 768px) {
    padding-left: 0px;
  }
  @media (min-width: 1123px) {
    padding-left: 0px;
  }
`
export const InputDiv = styled(`div`)`
  width: 100%;
  max-width: 18.75em;
  height: 2.5em;
  border-radius: 4px;
  background-color: ${props => props.theme.footerSection.inputBackground};
  display: flex;
  justify-content: center;
`
export const Button = styled(`button`)`
  background-color: ${props => props.theme.footerSection.filledButtonBGColor};
  outline: none;
  border: none;
  text-align: center;
  padding: 0.563em 1.5em 0.563em 1.5em;
  border-radius: 4px;
  margin-top: 0.625em;
`
export const QuickLinks = styled(`div`)`
  display: flex;
  flex-direction: column;
  margin-top: 2.5em;
  margin-bottom: 1.875em;
  @media (min-width: 320px) and (max-width: 767px) {
    width: 100%;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    align-items: flex-start;
    margin-left: 30px;
    margin-right: 30px;
    margin-top: 0;
  }
  @media (min-width: 1025px) {
    margin: 0px;
    align-items: flex-start;
  }
`
export const RobotoSpan = RobotoRegular.withComponent(`a`)

export const PageLink = styled(RobotoSpan)`
  opacity: 0.8;
  font-size: 0.875em;
  line-height: 1.23;
  text-align: start;
  color: ${props => props.theme.footerSection.pageLinksColor};
  margin-bottom: 0.625em;
  text-decoration: none;
  cursor: pointer;
  outline: none;
  :hover {
    text-decoration: none;
    outline: none;
    color: ${props => props.theme.footerSection.pageLinksColor};
  }
  :focus {
    text-decoration: none;
    outline: none;
    color: ${props => props.theme.footerSection.pageLinksColor};
  }
  @media (min-width: 320px) and (max-width: 767px) {
    width: 50%;
    text-align: start;
  }
  @media (min-width: 768px) {
    margin-bottom: 1.125em;
  }
`
export const CopyRight = styled(RobotoRegular)`
  line-height: 1.36;
  text-align: center;
  margin-bottom: 0px;
  font-size: 0.875em;
  color: ${props => props.theme.footerSection.lightTextColor};
  @media (min-width: 768px) {
    text-align: left;
    padding-top: 0.75em;
    padding-bottom: 3.375em;
  }
`
export const ReachUsHeading = styled(RobotoThickMedium)`
  margin-bottom: 5px;
  font-size: 0.875em;
  @media (min-width: 768px) {
  }
  @media (min-width: 1123px) {
  }
`
export const MobileReachUsHeading = styled(ReachUsHeading)`
  width: 100%;
`
export const AddressHeading = styled(RobotoThickMedium)`
  margin-bottom: 5px;
  font-size: 0.875em;
  @media (min-width: 320px) and (max-width: 767px) {
    width: 100%;
  }
  @media (min-width: 768px) {
    margin-top: 1.286em;
  }
  @media (min-width: 1123px) {
    margin-top: 1.125em;
  }
`

export const ReachAndAddressSection = styled(`div`)``

export const AddressSection = styled(`div`)`
  margin-bottom: 3.75em;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  @media (max-width: 767px) {
    width: 100%;
  }
  @media (min-width: 768px) {
    display: block;
    margin-bottom: 0px;
  }
  @media (min-width: 1123px) {
    display: block;
    margin-bottom: 0px;
  }
`
export const ReachUsSection = styled(AddressSection)`
  margin-bottom: 2.5em;
`
export const AddressLine = styled(RobotoRegular)`
  opacity: 0.6;
  font-size: 0.875em;
  line-height: 1.54;
  padding-bottom: 4px;
  color: ${props => props.theme.footerSection.white};
  margin: 0px;
  @media (min-width: 768px) {
    line-height: 1.54;
    color: ${props => props.theme.footerSection.white};
    opacity: 0.6;
  }
`
export const AddressLineContainer = styled(RobotoRegular)`
  display: flex;
  flex-direction: column;
`

export const MobileAddressLine = styled(AddressLine)`
  width: 100%;
`

export const AddressLineWithDiv = AddressLine.withComponent('div')

export const AddressLineDescription = styled(AddressLineWithDiv)`
  width: 100%;
`

export const AddressLineInfo = styled(AddressLine)`
  padding-left: 5px;
`

export const AddressLineInfo2 = styled(AddressLine)`
  padding-left: 5px;
`

export const MailAddressLine = styled(RobotoSpan)`
  opacity: 0.6;
  font-size: 0.875em;
  text-decoration: none !important;
  :hover {
    color: ${props => props.theme.footerSection.white};
  }
  :focus {
    color: ${props => props.theme.footerSection.white};
  }
  line-height: 1.54;
  cursor: pointer;
  padding-bottom: 4px;
  color: ${props => props.theme.footerSection.white};
  margin: 0px;
  @media (min-width: 768px) {
    line-height: 1.54;
    color: ${props => props.theme.footerSection.white};
    opacity: 0.6;
  }
`

export const MobileMailAddressLine = styled(MailAddressLine)`
  width: 100%;
`

export const ReachItem = styled(`div`)`
  display: flex;
  align-items: center;
  min-width: 10em;
  svg {
    margin-right: 8px;
    margin-bottom: 4px;
  }
  @media (min-width: 320px) and (max-width: 767px) {
    width: 100%;
  }
`

export const ReachItemGroup = styled(`div`)``

export const NewsLetterSection = styled(`div`)`
  @media (min-width: 768px) {
    width: 17.063em;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`
export const NewsLetterSubHeading = styled(RobotoRegular)`
  opacity: 0.6;
  font-size: 0.875em;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: ${props => props.theme.footerSection.white};
`
export const NewsLetterHeading = styled(RobotoLightMeduimSoft)`
  font-size: 1.5em;
  @media (min-width: 768px) {
    margin-bottom: 4px;
  }
`
export const ButtonText = styled(RobotoRegular)`
  font-style: normal;
  font-size: 0.875em;
  font-stretch: normal;
  letter-spacing: normal;
  color: #ffffff;
  margin: 0px;
`
export const ProyugaFooterLogo = styled('img')`
  width: 71px;
  height: 88px;
  @media (max-width: 767px) {
    width: 56px;
    height: 70px;
  }
`
export const IconWithLink = styled('a')``

export const SocialIconsContainer = styled('div')`
  display: flex;
  flex-direction: row;
  width: 10em;
  padding-top: 1.813em;
  justify-content: space-between;
`

export const FBIcon = props => (
  <IconWithLink href="http://www.facebook.com/">
    <IcFacebook />
  </IconWithLink>
)

export const TwitterIcon = props => (
  <IconWithLink href="http://www.twitter.com/">
    <IcTwitter />
  </IconWithLink>
)

export const InstagramIcon = props => (
  <IconWithLink href="http://www.instagram.com/">
    <IcInstagram />
  </IconWithLink>
)

export const YoutubeIcon = props => (
  <IconWithLink href="http://www.youtube.com/">
    <IcYoutube />
  </IconWithLink>
)

export const PageLinksContainer = styled('div')`
  @media (min-width: 320px) and (max-width: 767px) {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  @media (min-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`

export const SectionsContainer = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
`

export const LinksSectionsContainer = styled('div')`
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: 320px) and (max-width: 767px) {
    width: 250px;
  }
`

export const LogoQuickLinksSection = styled('div')`
  display: flex;
  justify-content: space-between;
`

export const EmailError = styled(NewsLetterSubHeading)`
  margin-top: 0.315em;
  margin-bottom: 0px;
`
export const EmailSuccess = styled(EmailError)``
